import { selectVisibleOrthoFlights } from "features/entity-caching/flights/selectors"
import OrthoOverlapLayer from "features/map/layers/bitmap/ortho-overlap/OrthoOverlapLayer.class"
import { useAppSelector } from "integrations/redux/hooks"
import { selectAllUploads } from "../OrthomosaicSlice"
import { useOrthoOverlap } from "plugins/shared/layers/ortho-overlap/useOrthoOverlap"

export const useRGBOrthoOverlapLayer = () => {
    const allUploadsById = useAppSelector(selectAllUploads())
    const flights = useAppSelector(selectVisibleOrthoFlights)
    const { overlapImages } = useOrthoOverlap({ allUploadsById, flights, type: "rgb" })

    return new OrthoOverlapLayer({
        id: "Ortho-Overlap",
        data: overlapImages,
    })
}
